import { useTranslations } from '@ifixit/i18n/hooks';
import { useUIContext } from './context';
import { FaIcon } from './icon';
import { cn } from '../lib/utils';

interface WorkbenchIconProps {
   onClick?: () => void;
   href?: string;
   className?: string;
}

export function WorkbenchIcon({ onClick, href, className }: WorkbenchIconProps) {
   const t = useTranslations('Workbench');
   const { Link } = useUIContext();
   const sharedClassName = cn(
      'inline-flex items-center justify-center rounded-md p-2 text-white transition-opacity duration-300 hover:opacity-70 active:bg-gray-900',
      className
   );

   if (href) {
      return (
         <Link
            href={href}
            aria-label={t('openWorkbench')}
            id="workbenchDropdownToggle"
            className={sharedClassName}
         >
            <FaIcon name="toolbox" className="size-6" />
         </Link>
      );
   }

   return (
      <button
         type="button"
         aria-label={t('openWorkbench')}
         onClick={onClick}
         id="workbenchDropdownToggle"
         className={sharedClassName}
      >
         <FaIcon name="toolbox" className="size-6" />
      </button>
   );
}
